import { cn, Radio, RadioGroup } from '@heroui/react';
import { formatPonderacion } from '@/utils';

interface Answer {
    nRespuesta: number;
    cDescripcion: string;
    ponderacion?: number;
}

interface RadioGroupFieldProps {
    answers: Answer[];
    setValue: (value: string) => void;
    value: string;
    isDisabled?: boolean;
}

const RadioGroupField = ({ value, answers, setValue, isDisabled }: RadioGroupFieldProps) => {
    return (
        <RadioGroup isReadOnly={isDisabled} orientation="horizontal" className='flex justify-center' classNames={{wrapper: 'justify-center'}} value={value} onValueChange={setValue}>
            {answers.map((answer, index) => (
                <Radio classNames={{
                    wrapper: 'hidden',
                    base: cn(
                        "inline-flex m-0 bg-default-200 hover:bg-primary-200 items-center justify-between",
                        "flex-row-reverse max-w-[300px] cursor-pointer rounded-lg gap-4 p-4 border-2 border-transparent",
                        "data-[selected=true]:border-primary data-[selected=true]:bg-primary-200 data-[selected=true]:color-white",
                    )
                }} key={index} value={String(answer.nRespuesta)}>
                    <span className="flex items-center gap-1">
                        {answer.cDescripcion}
                        {answer.ponderacion != null && (
                            <span className="text-sm text-default-500">
                                ({formatPonderacion(answer.ponderacion)})
                            </span>
                        )}
                    </span>
                </Radio>
            ))}
        </RadioGroup>
    );
};

export default RadioGroupField;
